import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Input, Popover } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import withTranslations from 'app/components/HOGs/withTranslations';

const FolderInput = ({ value, onKeyDown, onChange, warning, isMobile, tr }) => {
  const getSuffix = () => <CloseCircleFilled onClick={() => onChange('')} />;
  return !isMobile ? (
    <Popover
      content={
        warning.show ? (
          <Alert
            message={() => (
              <FormattedMessage
                id={warning.text}
                defaultMessage={warning.text}
              />
            )}
            type="error"
            showIcon
          />
        ) : null
      }
      visible={warning.show}
      placement="bottom"
      align={{ offset: [0, 0] }}
      overlayClassName="folder-warning"
    >
      <Input.TextArea
        placeholder={tr['Write name']}
        className="menuNewFolderInput"
        value={value}
        suffix={getSuffix()}
        onKeyDown={onKeyDown}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        onFocus={(e) => e.target.select()}
        autoSize={{
          minRows: 1,
          maxRows: 3,
        }}
      />
    </Popover>
  ) : (
    <>
      <Input.TextArea
        placeholder={tr['Write name']}
        className="menuNewFolderInput"
        value={value}
        suffix={getSuffix()}
        onKeyDown={onKeyDown}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        onFocus={(e) => e.target.select()}
        autoSize={{
          minRows: 1,
          maxRows: 3,
        }}
      />
      {warning.show ? (
        <div>
          <Alert
            message={() => (
              <FormattedMessage
                id={warning.text}
                defaultMessage={warning.text}
              />
            )}
            type="error"
            showIcon
          />
        </div>
      ) : null}
    </>
  );
};
FolderInput.propTypes = {
  value: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  warning: PropTypes.shape({
    text: PropTypes.string,
    show: PropTypes.bool,
  }),
};

export const warnings = Object.freeze({
  empty: Object.freeze({
    text: '',
    show: false,
  }),
  wrongName: Object.freeze({
    text: 'Folder with this name already exist. Choose another name',
    show: true,
  }),
  maxLength: Object.freeze({
    text: 'The folder name cannot exceed 255 characters',
    show: true,
  }),
});

export default withTranslations(FolderInput);
